module.exports = __webpack_public_path__ + "static/Kelly-b715e3824d51814ee57876becda6d352.png";